export enum TabType {
    WORLD_MAP = 'world_map',
    PACKS_LIST = 'packs_list',
}
